'use client'

import { create } from 'zustand'

/**
 * Carries a server fault from `handleApiError` (a plain module, no React
 * context, therefore no translator) to `<ApiErrorToast />`, which owns the
 * localized copy.
 *
 * Nothing about the failure travels here except the trace id: the backend
 * message, status code and error slug are diagnostics and stay in the
 * `console.error` that `handleApiError` already writes. This mirrors the 402
 * branch of the same function, which likewise hands the outcome to a store
 * (`billing-dialog-store`) and lets a component render it.
 */
interface ApiErrorToastState {
  /** Increments per report so a repeat fault re-triggers the subscriber. */
  seq: number
  /** Support handoff id, copyable from the toast. Absent when unknown. */
  traceId: string | null
}

interface ApiErrorToastActions {
  report: (traceId?: string) => void
}

export const useApiErrorToastStore = create<
  ApiErrorToastState & ApiErrorToastActions
>()((set) => ({
  seq: 0,
  traceId: null,

  report: (traceId) =>
    set((prev) => ({ seq: prev.seq + 1, traceId: traceId ?? null })),
}))
